<template>
	<div id="app">
		<router-view />

	</div>
</template>

<script>
	import "./assets/css/common.scss";
	import "./assets/css/base.css";
	import "./assets/css/_dialog.scss";
	export default {
		name: "App",
		data() {
			return {

			};
		},
		mounted() {
			this.request
				.get(`${this.WITSBOX_ENV_PARAM.baseUrl}/common/systemParameter/aliyun`)
				.then((res) => {
					if (res.dataModel) {
						let dataModel = res.dataModel || {}
						localStorage.setItem('PARAMOssObject', JSON.stringify(dataModel))
						this.WITSBOX_ENV_PARAM.ossObject = {
							accessKeyId: dataModel.accessKey,
							accessKeySecret: dataModel.accessSecret,
							bucket: dataModel.bucket,
							region: dataModel.accelerateRegion || dataModel.region
						}
					}
				})

		},
		methods: {

		},

	};
</script>

<style lang="scss" scoped>
	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		height: 100%;
	}

	.loginDialog {
		padding: 20px;
		width: 320px;

		.title {
			text-align: center;
			font-size: 20px;
			margin-bottom: 20px;
			// font-weight: 600;
		}

		.loginDialogBox {
			text-align: left;

			.loginInputBox {
				width: 100%;
				height: 40px;
				border-radius: 23px;
				background: #fff;
				border: 1px solid rgba(31, 133, 252, 0.1);
				box-shadow: inset -1px -1px 1.5px 0px #fdfeff,
					inset -5px -5px 15.5px 0px #ffffff,
					2px 3px 11px 0px rgba(197, 200, 214, 0.5) inset,
					0px 0px 2.5px 0px #c5c8d6;

				.login-input {
					border: none;
					border-radius: 23px;
					background: none;
					height: 30px;
					line-height: 30px;
					margin: 4px 15px;
				}
			}
		}

		.cancel-btn {
			border: 1px solid rgba(31, 133, 252, 0.1);
			border-radius: 20px;
			width: 100px;
			height: 30px;
			line-height: 30px;
			box-shadow: -7px -7px 16px 0px #fffcfc,
				8px 6px 23.75px 1.25px rgba(173, 199, 229, 0.55);
			background: #fff;
		}

		.lsee {
			border-radius: 20px;
			width: 100px;
			color: #ffffff;
			height: 30px;
			line-height: 30px;
			background-image: linear-gradient(to right, #77b4ff, #1f85fc);
			box-shadow: 2px 2px 6.175px 0.325px #bec1cf, -2px -2px 4px 0px #fafbfc;
		}
	}
</style>


// WEBPACK FOOTER //
// src/App.vue